export const DO_LOGIN = "DO_LOGIN";
export const DO_LOGOUT = "DO_LOGOUT";
export const SET_AUTENTICACAO = "SET_AUTENTICACAO";
export const SET_LOGOUT = "SET_LOGOUT";
export const SET_LISTTOURS = 'SET_LISTTOURS';
export const UPDATE_TOURTODO = 'UPDATE_TOURTODO';
export const SET_EHMOBILE = 'SET_EHMOBILE';

export const GET_TOURS = "GET_TOURS";
export const SAVE_TOURS_USUARIO = "SAVE_TOURS_USUARIO"; 
export const SET_PESQUISA_SATISFACAO = "SET_PESQUISA_SATISFACAO"; 
